'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import SideMenu from './sideMenu';
import NavBar from './navBar';
import AllHeader from './attdComponents/allHeader';
import AllBody from './attdComponents/allBody';
import attdAction from '../actions/attdAction';
import attdStore from '../stores/attdStore';
import userStore from '../stores/userStore';
import menuAction from '../actions/menuAction';
import Loading from './loading';

class AttendanceAll extends React.Component {
    constructor(props) {
        super(props);
        this.onChange= this.onChange.bind(this);
        this.onUserChange =this.onUserChange.bind(this);
        this.state={
            staffsAtd: attdStore.getState().staffsAtd,
            selectedYear: attdStore.getState().selectedYear,
            selectedMonth: attdStore.getState().selectedMonth,
            iniLoad: attdStore.getState().iniLoad,
            processing: attdStore.getState().processing,
            role: userStore.getState().role,
        };
    }
    componentDidMount(){
        attdStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        menuAction.pageNumber.defer(-1);

        if(!this.state.iniLoad && !this.state.processing){
            attdAction.processing(true);
            attdAction.getAllStaffAttendance(this.state.selectedYear, this.state.selectedMonth);
        }
    }
    componentWillUnmount() {
        attdStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state){
        this.setState({
            role: state.role
        });
    }
    onChange(state){
        this.setState({
            staffsAtd: state.staffsAtd,
            selectedYear: state.selectedYear,
            selectedMonth: state.selectedMonth,
            processing: state.processing,
        });
    }
    render() {
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props}/>
                    <SideMenu {...this.props}/>
                    <div className=" col-md-10  col-sm-8 atd">
                        <AllHeader />
                        <div className="divider"></div>
                        <AllBody staffsAtd={this.state.staffsAtd} role={this.state.role} useFor={0} processing={this.state.processing}/>
                    </div>
                </div>
                <Loading processing={this.state.processing}/>
            </div>
        );
    }
}
export default AttendanceAll;


// WEBPACK FOOTER //
// ./app/components/attendanceAll.js